import { render, staticRenderFns } from "./NotVisit.vue?vue&type=template&id=b5238734&"
import script from "./NotVisit.vue?vue&type=script&lang=js&"
export * from "./NotVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports